module.exports = __webpack_public_path__ + "static/media/icons-ic-paused-stroke.91a70e3d.svg";